import { z } from 'zod';

export const menuLabelSchema = z.object({
  menuKey: z.string(),
  label: z.string(),
});

export const menuLabelListSchema = z.array(menuLabelSchema);

export type MenuLabel = z.infer<typeof menuLabelSchema>;

export interface MenuNameActions {
  onRename: (menuKey: string, label: string) => void;
  onUndo: (menuKey: string) => void;
  onReset: (menuKey: string) => void;
}
